import { SEVERITY } from "helpers/utils.js";
import {
  GET_SUPPLIER,
  GET_SUPPLIER_SUCCESS,
  GET_SUPPLIER_FAIL,
  GET_SUPPLIER_BY_ID_SUCCESS,
  ADD_NEW_SUPPLIER,
  ADD_NEW_SUPPLIER_SUCCESS,
  UPDATE_SUPPLIER,
  UPDATE_SUPPLIER_SUCCESS,
  DELETE_SUPPLIER,
  DELETE_SUPPLIER_SUCCESS,
  SUPPLIER_CLEAR_NOTIFY,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const supplier = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_NEW_SUPPLIER:
    case UPDATE_SUPPLIER:
    case DELETE_SUPPLIER:
    case GET_SUPPLIER:
      return {
        ...state,
        loading: true,
      };
    case GET_SUPPLIER_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_SUPPLIER_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };

    case ADD_NEW_SUPPLIER_SUCCESS:
      return {
        ...state,
        message: {
          title: "Supplier",
          text: "Supplier has been added successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case UPDATE_SUPPLIER_SUCCESS:
      return {
        ...state,
        message: {
          title: "Supplier",
          text: "Supplier has been updated successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case DELETE_SUPPLIER_SUCCESS:
      return {
        ...state,
        message: {
          title: "Supplier",
          text: "Supplier has been deleted successfully.",
          severity: SEVERITY.INFO,
        },
      };
    case GET_SUPPLIER_FAIL:
      return {
        ...state,
        error: payload,
      };
    case SUPPLIER_CLEAR_NOTIFY:
      return {
        ...state,
        message: null,
      };
    default:
      return state;
  }
};

export default supplier;
